import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AgentApplication } from '../model/agent.application';
import { GenericResponse } from '../model/generic.response';
import { AppSettings } from '../settings/app-settings';
import { CompanyService } from './company.service';
import { CountryService } from './country.service';

@Injectable({
    providedIn: 'root'
})
export class AgentService {

    constructor(
        private http: HttpClient,
        private companyService: CompanyService,
        private countryService: CountryService,
    ) { }

    getAgentApplications(form: FormGroup) {
        form.value.companyId = this.companyService.getSelectedCompany().id;
        return this.http.post<GenericResponse<AgentApplication[]>>(
            AppSettings.API_ENDPOINT + AppSettings.GET_AGENT_APPLICATIONS,
            JSON.stringify(form.value),
        );
    }
}

